import router from '@/router';
import store from '@/store';

const goBack = (force = false) => {
    if (force) {
        window.history.back();
    } else {
        if (store.getters['routerHistory/hasHistory']) {
            router.back();
        } else {
            router.push({ name: 'Dashboard' });
        }
    }
};

export default goBack;
